{
  "name": "platform-portal",
  "version": "2.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 4201",
    "build": "ng build",
    "build-internal": "ng build --configuration internal",
    "build-gbl": "ng build --configuration global",
    "build-trn": "ng build --configuration trn",
    "build-development": "ng build --configuration development",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "stylelint": "npx stylelint \"**/*.scss\""
  },
  "private": true,
  "engines": {
    "npm": "11",
    "node": "22"
  },
  "dependencies": {
    "@angular/animations": "19.1.4",
    "@angular/cdk": "^19.1.2",
    "@angular/common": "19.1.4",
    "@angular/compiler": "19.1.4",
    "@angular/core": "19.1.4",
    "@angular/forms": "19.1.4",
    "@angular/material": "^19.1.2",
    "@angular/platform-browser": "19.1.4",
    "@angular/platform-browser-dynamic": "19.1.4",
    "@angular/router": "19.1.4",
    "@azure/msal-angular": "^4.0.3",
    "@azure/msal-browser": "^4.1.0",
    "@faker-js/faker": "^9.4.0",
    "@shortercode/webzip": "^1.1.1-0",
    "ajv": "^8.17.1",
    "ajv-formats": "^3.0.1",
    "crc": "^4.3.2",
    "ejs": "^3.1.10",
    "fast-deep-equal": "^3.1.3",
    "i": "^0.3.7",
    "js-yaml": "^4.1.0",
    "luxon": "^3.5.0",
    "monaco-editor": "^0.52.2",
    "p-limit": "^6.2.0",
    "rxjs": "^7.8.1",
    "uuid": "^11.0.5",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.1.5",
    "@angular/cli": "19.1.5",
    "@angular/compiler-cli": "19.1.4",
    "@types/jasmine": "^5.1.4",
    "@types/js-yaml": "^4.0.9",
    "@types/json-patch": "^0.0.33",
    "@types/luxon": "^3.4.2",
    "@types/uuid": "^10.0.0",
    "angular-eslint": "^19.0.2",
    "eslint": "^9.19.0",
    "jasmine-core": "^5.5.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "stylelint": "^16.14.1",
    "stylelint-config-standard-scss": "^14.0.0",
    "tslib": "^2.8.0",
    "typescript": "^5.7.3",
    "typescript-eslint": "^8.23.0"
  }
}
